import React, { memo, RefObject } from 'react';

import Pause from 'assets/images/pause-fill.svg';
import ButtonLink from 'components/button-link';
import Image from 'components/image';

interface IPauseButton {
  innerRef: RefObject<HTMLButtonElement>;
  onClick: () => void;
}

const PauseButton: React.FC<IPauseButton> = ({ innerRef, onClick }) => {
  return (
    <ButtonLink innerRef={innerRef} className="pause-btn bottom-controls" onClick={onClick} >
      <div className="background" />
      <Image src={Pause} />
    </ButtonLink>
  );
};

export default memo(PauseButton);
